import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { ModalHeaderDefault } from '@/shared/ui/modal';

type DiscardChangesModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onDiscard: () => void;
};

export const DiscardChangesModal = ({ isOpen, onCancel, onDiscard }: DiscardChangesModalProps) => (
  <Modal open={isOpen} size="xs" onClose={onCancel}>
    <ModalHeaderDefault
      title="You have unsaved changes"
      subtitle="If you exit now, your changes will be lost."
      onClose={onCancel}
    />

    <ModalActions>
      <Button data-testid="teamspace-cancel-discard-changes" variant="outlined" fullWidth onClick={onCancel}>
        Cancel
      </Button>
      <Button data-testid="teamspace-confirm-discard-changes" variant="error" fullWidth onClick={onDiscard}>
        Discard changes
      </Button>
    </ModalActions>
  </Modal>
);
